"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
require("./Types");
const postcss_1 = __importDefault(require("postcss"));
const PostCSSPlugin_1 = __importDefault(require("./plugin/PostCSSPlugin"));
module.exports = (0, PostCSSPlugin_1.default)(postcss_1.default);
